<template>
    <popover v-if="isShowing" width="300px" height="200px" @close="abort">
        <div class="login f-column">
            <div class="header">{{ SelectedCompetition.name }}</div>
            <div class="body f-grow">
                <c-input :title="$t('text.password')" v-model="password" labelWidth="80px" :error="errorPW" :forceFocus="true" :doubleDot="true" @enter="login"></c-input>
            <!-- <message class="message" v-if="hasLoginFailed" type="warning" size="xs" :text="$t('text.errorLogin')"></message> -->
            <message v-if="autoLogin" type="hint" size="xs" :text="$t('text.tryAutoLogin')"></message>
            </div>
            <div class="footer">
                <button @click="abort" :disabled="!!autoLogin" class="abort">{{$t('text.abort')}}</button>
                <button @click="login" :disabled="!!autoLogin" class="important">{{$t('text.login')}}</button>
            </div>
        </div>
    </popover>
</template>

<script>

import { mapMutations, mapActions, mapGetters } from 'vuex';
import Popover from './Popover.vue';
import Message from './Message.vue'
import CInput from './CInput.vue'

import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import compMut from '../store/mutations/competition';
import setMut from '../store/mutations/settings';

export default {
    name: "login",
    data: function() {
        return {
            password: "",
            failedAttempt: false,
            autoLogin: false,
            logon: () => {
                this.SETLOGIN({pw: this.password, id: this.SelectedCompetition.id });
                this.SENDHEARTBEAT();
                this.SETLANG({t: this, locale: this.SelectedCompetition.defaultLanguage})
                if(this.$route.params.hId || JSON.parse(localStorage.getItem('sHeatGuid'))) {
                    const guid = this.$route.params.hId || JSON.parse(localStorage.getItem('sHeatGuid'));
                    this.SETSELECTEDHEAT({id:guid, heat: undefined});
                    this.$router.push('/competition/events/event/');
                }
                else{
                    this.$router.push('/competition/events/' );
                }
            },
            loginFailed: () => {
                this.autoLogin = false;
                this.failedAttempt = true;
            }
        }
    },
    methods:{
        ...mapMutations([glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,
            glMut.LOGOUT,
            glMut.SETLOGIN,
            glMut.SETSELECTEDHEAT,
            compMut.SETSELECTEDCOMPETITION,
            setMut.SETLANG,]), 
        ...mapActions([glAct.LOGIN,
            glAct.SENDHEARTBEAT]),  
        login (){
            this.LOGIN({ pw: this.password});
        },
        abort (){
            this.$router.go(-1);
            this.$i18n.locale = this.LocaleFallBack;
        },
    },
    computed:{
        ...mapGetters(['Connection', 'LocaleFallBack']), 
        ...mapGetters(['Competitions', 'SelectedCompetition', 'CId', 'Pw']), 
        isShowing(){
            return this.$route.path.includes('/login') && !!this.SelectedCompetition;
        },
        isLoginSet(){
            return !!this.CId && !!this.Pw;
        },
        errorPW (){
            return {
                show: this.failedAttempt,
                message: this.$i18n.t('text.errorLogin'),
            }
        }
    },
    components: {
        Popover,
        Message,
        CInput
    },
    created (){
        if(this.$route.params.cId) {
            const comp = this.Competitions.find(obj => { return obj.id == this.$route.params.cId});
            if(comp)
                this.SETSELECTEDCOMPETITION(comp);
        }
        if(!this.SelectedCompetition && !this.isLoginSet)
        {
            this.$router.push('/dashboard');
        }
        else{
            if(this.SelectedCompetition && this.SelectedCompetition.defaultLanguage){
                this.$i18n.locale = this.SelectedCompetition.defaultLanguage;
            }
            var RegisterMethods = () => {

                this.REGISTERHUB({
                    name: "AccessGranted",
                    method: this.logon
                });

                this.REGISTERHUB({
                    name: "AccessDenied",
                    method: this.loginFailed
                });

                if(this.CId && this.Pw){
                    this.password = this.Pw;
                    this.autoLogin = true;
                    const comp = this.Competitions.find(obj => { return obj.id == this.CId})
                    if(comp) {
                        this.SETSELECTEDCOMPETITION(comp);
                        this.LOGIN({ pw: this.password});
                    }
                    else {
                        this.LOGOUT();
                        this.autoLogin = false;
                    }
                }

            }

            if(this.Connection != ""){
                RegisterMethods();
            }

            this.$store.subscribe((mutation, state) => {
                if(mutation.type == glMut.SETCONNECTION && state.glModule.connection != ""){
                    RegisterMethods();
                }
            });
        }
    },
    beforeDestroy(){
        this.UNREGISTERHUB({
                name: "AccessGranted",
                method: this.logon
        });

        this.UNREGISTERHUB({
            name: "AccessDenied",
            method: this.loginFailed
        });
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .login {
        padding: $spacer_s;
        height: 100%;
        box-sizing: border-box;
    }

    .header {
        font-weight: bold;
        padding-bottom: $spacer_xs;
    }

    .body {
        border-top: silver solid 1px;
        padding-top: $spacer_s;
        font-size: 10px;
        input {
            width:98%;
            background-color:$sec_bg_color;
            border: solid 1px $prim_border_color;
        }
        button {
            background-color:$sec_bg_color;
            border: solid 1px $prim_border_color;
            cursor: pointer;
        }
    }
    .footer {
        text-align: right;
    }

    button {
        height: 40px;
        padding-left: 20px;
        padding-right: 20px;
        font-weight: bold;
        font-size: 14px;
    }

    .important {
        background-color: $seltec_color!important;
    }

    .abort {
        margin-right: 10px;
        background-color: transparent!important;
        border-color: transparent!important;
        color: #fff;
    }

</style>